import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `table` + sortable/filterable column menus + expandable rows.
export const styles = {
  toolbar: {
    k1xSpc: "x78zum5",
    kjj79g: "x13a6bvl",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1mnnc3i",
    k1K539: "x1fsj9pq",
    $$css: true
  },
  toolbarStart: {
    kzQI83: "x1iyjqo2",
    kmuXW: "xs83m0k",
    k7Eaqz: "xeuugli",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    $$css: true
  },
  clearf: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xomqrzn",
    kMwMTN: "x1459q0w",
    kkrTdU: "x1ypdohk",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kmVPX3: "x4jth1y",
    kaIpWk: "x1d0dq8e",
    kGzVvX: "x5lqt2c",
    $$css: true
  },
  clearfHidden: {
    k33iCy: "xlshs6z",
    $$css: true
  },
  body: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  busy: {
    kVAEAm: "x10l6tqk",
    kpwlN0: "x10a8y8t",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kY2c9j: "xzkaem6",
    $$css: true
  },
  moreBelow: {
    kVAEAm: "x10l6tqk",
    kbCHJM: "x1nrll8i",
    krVfgx: "xd09sc1",
    k3aq6I: "xuuh30",
    kY2c9j: "xzkaem6",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "x14qfxbe",
    kZKoxP: "xc9qbxq",
    kmVPX3: "x1717udv",
    kaIpWk: "xoy5co8",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kWkggS: "x13uruat x5lqt2c",
    kMwMTN: "xdxw5r1",
    kGVxlE: "x7g3v46",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  wrapBusy: {
    kSiTet: "xyd83as",
    kfzvcC: "x47corl",
    $$css: true
  },
  wrap: {
    kXHlph: "xw2csxc",
    kORKVm: "x1odjw0f",
    kskxy: "x9ybwvh",
    kaIpWk: "x7tdnnd",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kWkggS: "x13uruat",
    $$css: true
  },
  table: {
    kzqmXN: "xh8yej3",
    kLvRdT: "x1mwwwfo",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2ouz8m",
    $$css: true
  },
  th: {
    k9WMMc: "xdpxx8g",
    k63SB2: "xomqrzn",
    kGuDYH: "x34ze3o",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    k8WAf4: "xyggvxn",
    kg3NbH: "x1dey2f9",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    khDVqt: "xuxw1ft",
    kVAEAm: "x7wzq59",
    k87sOh: "x13vifvy",
    kY2c9j: "xhtitgo",
    kWkggS: "xvys5x3",
    $$css: true
  },
  wrapLedger: {
    kskxy: "xzuc9lq",
    kMzoRj: "xc342km",
    kaIpWk: "x1xv63ag",
    kWkggS: "xjbqb8w",
    $$css: true
  },
  tableLedger: {
    kPzzVL: "x140o2bo",
    k7Eaqz: "xmj3umr",
    $$css: true
  },
  thLedger: {
    k9WMMc: "xdpxx8g",
    k63SB2: "xomqrzn",
    kGuDYH: "x34ze3o",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    kZKoxP: "x1vqgdyp",
    k8WAf4: "xt970qd",
    kZCmMZ: "xqzfil6 xj27nm4",
    kwRFfy: "x1r3l6gk x7bq610",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  thBtnLedger: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xlr87oj",
    kzqmXN: "xh8yej3",
    kmVPX3: "x1717udv",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x1qlqyl8",
    k63SB2: "x1pd3egz",
    kb6lSQ: "x4gjf66",
    kP9fke: "x5ftkge",
    kMwMTN: "xdxw5r1 x1tqbdv0",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  groupRow: {
    kZKoxP: "xc9qbxq",
    k8WAf4: "xt970qd",
    kg3NbH: "xb1fagy",
    kWkggS: "x16vpd03",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kGuDYH: "x34ze3o",
    k63SB2: "xomqrzn",
    kb6lSQ: "x9pfba7",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  groupCount: {
    keTefX: "x1yjqwgn",
    kMv6JI: "x1gs96k",
    kMwMTN: "x1oezkus",
    kb6lSQ: "x1i21sxh",
    $$css: true
  },
  tdMarked: {
    kGVxlE: "x1oi8tmz",
    $$css: true
  },
  tdLedger: {
    kZKoxP: "xn3w4p2",
    k8WAf4: "xt970qd",
    kZCmMZ: "xqzfil6 xj27nm4",
    kwRFfy: "x1r3l6gk x7bq610",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kXLuUW: "xxymvpz",
    kMwMTN: "xdxw5r1",
    kGuDYH: "x2pyw9z",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  thCol: {
    k8WAf4: "xt970qd",
    kg3NbH: "xnjsko4",
    $$css: true
  },
  thChev: {
    kzqmXN: "x100vrsf",
    k8WAf4: "xt970qd",
    kg3NbH: "xnjsko4",
    $$css: true
  },
  thBtn: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xlr87oj",
    kzqmXN: "xh8yej3",
    k8WAf4: "xyggvxn",
    kg3NbH: "x1dey2f9",
    k9WMMc: "xdpxx8g",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k63SB2: "xomqrzn",
    kGuDYH: "x34ze3o",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    khDVqt: "xuxw1ft",
    kmkexE: "x1k3q35m",
    kGzVvX: "xij4iok",
    kDPRdz: "x1csad40",
    $$css: true
  },
  thBtnActive: {
    kMwMTN: "x1459q0w",
    $$css: true
  },
  cyc: {
    kMwMTN: "x1459q0w",
    k63SB2: "xomqrzn",
    kP9fke: "x6mezaz",
    kb6lSQ: "x12oo3zp",
    $$css: true
  },
  thIco: {
    kzqmXN: "x1fxhmyf",
    kZKoxP: "x18gnavp",
    kmuXW: "x2lah0s",
    kSiTet: "xti2d7y",
    kmkexE: "x1k3q35m",
    $$css: true
  },
  thIcoActive: {
    kSiTet: "x1hc1fzr",
    $$css: true
  },
  thIcoDesc: {
    k3aq6I: "x19jd1h0",
    $$css: true
  },
  alignRight: {
    k9WMMc: "x1hr2gdg",
    $$css: true
  },
  alignCenter: {
    k9WMMc: "x2b8uid",
    $$css: true
  },
  thBtnRight: {
    kjj79g: "x13a6bvl",
    $$css: true
  },
  thBtnCenter: {
    kjj79g: "xl56j7k",
    $$css: true
  },
  row: {
    kmkexE: "x1ujv9i6",
    kGzVvX: "x5lqt2c",
    $$css: true
  },
  rowClickable: {
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  rowFocusable: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    $$css: true
  },
  rowOpen: {
    kWkggS: "xvys5x3",
    $$css: true
  },
  td: {
    kmVPX3: "x1mgz3w",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kXLuUW: "xxymvpz",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  tdWrap: {
    khDVqt: "xeaf4i8",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  tdTruncate: {
    ks0D6T: "x1m189uc",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  tdMono: {
    kMv6JI: "x1gs96k",
    kGuDYH: "x1ct8sxb",
    $$css: true
  },
  footRow: {
    kWkggS: "x13uruat",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x17t0jj0",
    $$css: true
  },
  footTd: {
    kXLuUW: "x16dsc37",
    kmVPX3: "x1cgavqd",
    $$css: true
  },
  footTdLedger: {
    kXLuUW: "x16dsc37",
    k8WAf4: "x17nk906",
    kZCmMZ: "x1o12s23 xj27nm4",
    kwRFfy: "xmadbxi x7bq610",
    $$css: true
  },
  chevCell: {
    kzqmXN: "x100vrsf",
    kMwMTN: "x1em627c",
    $$css: true
  },
  srOnly: {
    kVAEAm: "x10l6tqk",
    kzqmXN: "x1i1rx1s",
    kZKoxP: "xjm9jq1",
    kmVPX3: "x1717udv",
    kogj98: "xkdpibf",
    kVQacm: "xb3r6kr",
    kz4h6p: "x1hyvwdk",
    khDVqt: "xuxw1ft",
    kMzoRj: "xc342km",
    $$css: true
  },
  chevBtn: {
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kmVPX3: "x1mvqyyz",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1heor9g",
    kkrTdU: "x1ypdohk",
    kaIpWk: "x1d0dq8e",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    $$css: true
  },
  chev: {
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kmkexE: "x1ojvxoa",
    $$css: true
  },
  chevOpen: {
    k3aq6I: "x1iffjtl",
    $$css: true
  },
  detailRow: {
    $$css: true
  },
  detailCell: {
    kmVPX3: "x1717udv",
    kWkggS: "x16vpd03",
    $$css: true
  },
  empty: {
    k9WMMc: "x2b8uid",
    kMwMTN: "xdxw5r1",
    kmVPX3: "x12atw6h",
    $$css: true
  },
  menu: {
    kVAEAm: "xixxii4",
    kY2c9j: "x68pp3s",
    k7Eaqz: "x13qflfw",
    kmVPX3: "xrqf348",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    kP9fke: "x6mezaz",
    kb6lSQ: "x12oo3zp",
    $$css: true
  },
  menuLabel: {
    kGuDYH: "x1s31vzs",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    k63SB2: "xomqrzn",
    kmVPX3: "x188mxx0",
    $$css: true
  },
  menuItem: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    kzqmXN: "xh8yej3",
    kmVPX3: "x1160tuk",
    kaIpWk: "x1d0dq8e",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMv6JI: "xdv2sak",
    kGuDYH: "x4z9k3i",
    k63SB2: "xssbmp7",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    k9WMMc: "xdpxx8g",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    kAkDo8: "x2j15wl x1lf23yt",
    kRG58y: "x1corrdc",
    $$css: true
  },
  menuItemOn: {
    kMwMTN: "x1oezkus",
    $$css: true
  },
  check: {
    koQZXg: "x8x9d4c",
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kaIpWk: "x12oqio5",
    kMzoRj: "xvndefy",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kMwMTN: "x19co3pv",
    kmuXW: "x2lah0s",
    $$css: true
  },
  checkOn: {
    kWkggS: "xlvhwkj",
    kVAM5u: "xa126vr",
    kMwMTN: "x1m3rtoy",
    $$css: true
  },
  sep: {
    kZKoxP: "xjm9jq1",
    kWkggS: "xkqg4d9",
    kogj98: "x1roee8s",
    $$css: true
  }
};